import * as React from 'react';
import Box from '@mui/material/Box';
import {useTheme} from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import YouTube from 'react-youtube';
import {useEffect} from "react";

export default function TextMobileStepper(props :any) {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = props.stretchingData.length;

  useEffect(() => {
  })
  
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  

  
  return (
    <Box sx={{flexGrow: 1 }}>
      <Paper
        square
        elevation={0}
        sx={{
          display: 'block',
          alignItems: 'center',
          height: 200,          
        }}
      >
        <div key={props.stretchingData[activeStep].name}>
          {/*  Youtube Component 사용 라이브러리 :  https://github.com/tjallingt/react-youtube   */}
          {props.stretchingData[activeStep].url === undefined || props.stretchingData[activeStep].url === '' ? (
              <Typography>관련 영상이 존재하지 않습니다.</Typography>
            ) : (
              <YouTube
                opts={{
                  height: 200,
                  display: 'block',
                  overflow: 'hidden',
                  width: '100%',
                }} 
               videoId={props.stretchingData[activeStep].url.split('/').reverse()[0]}
              />
          )}
        </div>
      </Paper>

      <Typography sx={{textAlign:'center', bgcolor:'#f5f5f5', p:1}}>{props.stretchingData[activeStep].name}</Typography>
    
      <MobileStepper
        variant="text"
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        sx={{fontSize:14}}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
            sx={backNext}
          >
            Next
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0} sx={backNext}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      />
    </Box>
  );
}

const backNext ={
  color:'#EF8322'
}